import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import PreviewCard from "../../../../V2/Cards/Product/ProductPreview"

import { useGetEcoSystemObjectFields } from "@hooks/V2/storyblok"
import { getUrlFromStoryblokLink, linkIsNotNull } from "@utils/storyblok"

const StoryblokProductPreviewCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.ProductPreviewCard>) => {
  const getEcoSystemObjectFields = useGetEcoSystemObjectFields()

  const ecoSystemFields = getEcoSystemObjectFields(blok?.productConfig)

  return (
    <PreviewCard
      mobileGridOrder={mobileGridOrder}
      productName={blok.productConfig.content.name}
      productDescription={
        blok.customDescription ||
        blok.productConfig.content.shortDescription ||
        ""
      }
      imageUrl={blok.productConfig.content.image.filename}
      imageAlt={blok.productConfig.content.image.alt}
      priceValue={ecoSystemFields?.price}
      detailLink={
        ecoSystemFields.detailsLink &&
        linkIsNotNull(ecoSystemFields.detailsLink)
          ? getUrlFromStoryblokLink(ecoSystemFields.detailsLink)
          : undefined
      }
      backgroundColor={blok.backgroundColor}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokProductPreviewCard
